<template>
  <div id="app">
    <div class="devlock" v-if="devlock">
      <div>
        <div class="spinner-animation">
    <span class="spinner"></span>
    <div class="content">Working ...</div>
</div>
      </div>
    </div>
    <div v-if="triggerEasterEgg" style="z-index: 900; position: absolute; top: 0px; left: 0px; height:100%; width: 100%; background-color: black; justify-content: center; align-content: center;">
      <table height="100%" width="100%">
        <tr><td align="center"><img style="height: 400px; margin: auto;" src="https://c.tenor.com/ULJn9_2K17UAAAAi/wazatoz-rick-roll.gif" />
        </td>
        </tr>
        </table>
    </div>
    <div class="canvas" :class="{ 'black' : ErrorDescription }">
      <header v-if="!ErrorDescription && provisioned" :class="{ 'adminoverride' : adminModeEnabled == true}">
        <div class="branding" v-on:click="openLid">{{ translation.BRANDING }}</div>
        <div class="clock">{{ time }}</div>

        <div class="lang">
          <select v-model="lang" v-on:change="setDefaultLanguage">
            <option v-for="l in languages.filter(e => e.code.length == 2)" :value="l.code">{{ translation[l.code] }}</option>
          </select>
        </div>

      </header>
      <section class="newversion" v-on:click="ReloadApp()" v-if="showVersionNeg && !testrunning" v-html="translation['STR_SOFTWARE_UPGRADE']">
      </section>
      <section :class="{ 'approot' : provisioned || ErrorDescription == '' }">
        <router-view v-if="proxyReachable &&  !ErrorDescription" :deviceType="deviceType" :ScreeningPortalEnabled="ScreeningPortalEnabled" :supportDetail="supportDetail" :transl="transl" :serial="serial" :version="version" :showVersionNeg="showVersionNeg" :ApoPortalApiEnabled="ApoPortalApiEnabled" :customer="customer" :customername="customername" @devlockf="devlockf" @adminmodeenabled="EnableAdminMode" @token="setToken" @triggerEasterEgg="triggerEasterEggH" @triggererror="triggerError" :hasResults="hasResults" :testrunning="testrunning" :online="online" :token="token" :translation="translation"></router-view>
        <div v-else class="proxyunreachable">
          <div class="error">
            <div style="text-align: left;">
            <h1 style="font-size: 80pt; padding: 0px; margin: 0px;text-align: center;"><i class="fas fa-exclamation-triangle"></i></h1>
            <h1 style="font-size: 40pt; padding: 0px; margin: 0px; font-weight: 100;">{{ ErrorDescription }}</h1>
            <h2 v-if="supportDetail" style="font-weight: 100"><b style="font-size: 30pt;">Support ID: </b> {{ supportDetail }}</h2>
            <h2 v-if="supportDetail" style="font-weight: 100"><b style="font-size: 30pt;">Support: </b> poc@procomcure.com</h2>
            <div class="reboot" v-on:click="reboot">Reboot Device</div>
            </div>
          </div>
        </div>
      </section>
      <footer v-if="!ErrorDescription && provisioned" :class="{ 'adminoverride' : adminModeEnabled == true}">
        <div class="connectivity">{{ getOnlineStatus }}</div>
        <div class="custname">{{ customername }}</div>
        <div v-if="!testrunning" class="support"><i v-on:click="GoTo('support')" class="fas fa-wrench"></i></div>
      </footer>
    </div>
  </div>
</template>

<script>
var jwt = require('jsonwebtoken');

export default {
  name: 'app',
  data() {
    return {
      devlock: false,
      deviceType: false,
      ScreeningPortalEnabled: false,
      triggerEasterEgg: false,
      adminModeEnabled: false,
      ApoPortalApiEnabled: false,
      version: false,
      showVersionNeg: false,
      customer: false,
      proxyReachable: false,
      debug: true,
      customername: null,
      ErrorDescription: null,
      lang: 'de',
      serial: null,
      testrunning: false,
      token: false,
      time: false,
      hasResults: false,
      provisioned: false,
      online: false,
      tvid: null,
      transl: {
        default: {
          lang_name: 'Unbranded',
          'ot': 'Other language',
          'de':'German',
          'en': 'English',
          'STR_MAINTENANCE': 'STR_MAINTENANCE',
          'STR_WELCOME_TO_POC': 'STR_WELCOME_TO_POC',
          'STR_WELCOME_TO_POC1': 'STR_WELCOME_TO_POC1',
          'STR_WELCOME_TO_POC2': 'STR_WELCOME_TO_POC2',
          'STR_WELCOME_TO_POC3': 'STR_WELCOME_TO_POC3',
          'STR_WELCOME_TO_POC4': 'STR_WELCOME_TO_POC4',
          'BRANDING': 'BRANDING',
          'STR_PLEASE_SCAN_SAMPLES': 'STR_PLEASE_SCAN_SAMPLES',
          'STR_SAMPLE_POSITIONS': 'STR_SAMPLE_POSITIONS',
          'STR_BARCODE': 'STR_BARCODE',
          'STR_START': 'STR_START',
          'STR_WELCOME': 'STR_WELCOME',
          'STR_WELCOME2': 'STR_WELCOME2',
          'STR_POSITION': 'STR_POSITION',
          'STR_TEST': 'STR_TEST',
          'STR_TEST_RESULT': 'STR_TEST_RESULT',
          'STR_CT_VALUE': 'STR_CT_VALUE',
          'STR_TEST_IN_PROGRESS': 'STR_TEST_IN_PROGRESS',
          'STR_EXPORT_ZMDX': 'STR_EXPORT_ZMDX',
          'STR_EXPORT_USB': 'STR_EXPORT_USB',
          'STR_REMAINING_TIME': 'STR_REMAINING_TIME',
          'STR_RESULT': 'STR_RESULT',
          'STR_WELLS_INSERTED': 'STR_WELLS_INSERTED',
          'STR_YES': 'STR_YES',
          'STR_NO': 'STR_NO',
          'STR_LID_CLOSED': 'STR_LID_CLOSED',
          'STR_POSITIVE': 'STR_POSITIVE',
          'STR_NEGATIVE': 'STR_NEGATIVE',
          'STR_NEW_TESST': 'STR_NEW_TESST',
          'STR_HUMAN_CONTROL': 'STR_HUMAN_CONTROL',
          'STR_VALID': 'STR_VALID',
          'STR_INVALID': 'STR_INVALID',
          'STR_SHUTDOWN': 'STR_SHUTDOWN',
          'STR_NEW_TEST': 'STR_NEW_TEST',
          'STR_STATISTICS': 'STR_STATISTICS',
          'STR_SERVICESTATUS': 'STR_SERVICESTATUS',
          'STR_OPENLID': 'STR_OPENLID',
          'STR_OVERVIEW': 'STR_OVERVIEW',
          'STR_LAST8TESTS': 'STR_LAST8TESTS',          
          'STR_TOTALTESTS':'STR_TOTALTESTS',
          'STR_POSITIVETESTS':'STR_POSITIVETESTS',
          'STR_QUOTEPOSITIVE':'STR_QUOTEPOSITIVE',
          'STR_TESTDATE':'STR_TESTDATE',
          'STR_TESTDATE':'STR_TESTDATE',
          'STR_SHOW':'STR_SHOW',
          'STR_TEST_CLEAN1':'Diese Werte wurden von Postiven- und negativen Kontrollen bereinigt.',
          'STR_TEST_CLEAN2': 'Diese Werte wurden von Postiven- und negativen Kontrollen bereinigt.',
          'STR_TEST_FROM': 'STR_TEST_FROM',
          'STR_MORE_DETAILS': 'STR_MORE_DETAILS',
          'STR_LIVE_SYSSTATUS': 'STR_LIVE_SYSSTATUS',
          'STR_MORE_DETAILS': 'STR_MORE_DETAILS',
          'STR_LIVE_SYSSTATUS1': 'Auf dieser Seite sehen Sie den Service Status unserer Backend Systeme, die relevanten Systeme werden im Zyklus von 60 Sekunden rund um die Uhr überwacht.',       
          'STR_SOFTWARE_UPGRADE': 'STR_SOFTWARE_UPGRADE',
        },
        ot: {
          lang_name: 'OTHER',
        },
        en: {
          lang_name: 'English',
          'de':'German',
          'en': 'English',
          'ot': 'Other language',
          'kl': 'Klingon',
          'STR_MAINTENANCE': 'Maintenance required',
          'STR_WELCOME_TO_POC': 'Welcome to your new PCR device!',
          'STR_WELCOME_TO_POC1': 'To use your new PCR device, you have to link it to your procomcure account, please visit our website <b>https://pcradmin.procomcure.com/code</b> or scan the QR code on the left side.',
          'STR_WELCOME_TO_POC2': 'Please enter the following pairing code on our website:',
          'STR_WELCOME_TO_POC3': 'After you paired your new device, it will automatically reboot - after this reboot you can start your first test immediately.',
          'STR_WELCOME_TO_POC4': '<b>Please note:</b> Your PCR device <b>requires a stable internet connection for the activation <u>and</u> for the daily operation</b>. If you need any assistance, feel free to contact us at <b>poc@procomcure.com</b>. Please always provide your Support ID (**supportDetail**) in case you contact us (our office times: Mo-Fri, 08am to 05pm UTC+1).',
          'BRANDING': 'PhoenixDx POC',
          'STR_PLEASE_SCAN_SAMPLES': 'Please scan Barcodes / Sample Numbers',
          'STR_SAMPLE_POSITIONS': 'Position of Probes:',
          'STR_BARCODE': 'Barcode / Sample Number',
          'STR_START': 'Start',
          'STR_WELCOME': 'Welcome to PhoenixDx POC!',
          'STR_WELCOME2': 'Please wait.',
          'STR_POSITION': 'Position',
          'STR_TEST': 'Test',
          'STR_TEST_RESULT': 'Test Result',
          'STR_CT_VALUE': 'CT Value',
          'STR_TEST_IN_PROGRESS': 'Test in progress ...',
          'STR_EXPORT_ZMDX': 'Export ZMDX',
          'STR_EXPORT_USB': 'Export USB ',
          'STR_REMAINING_TIME': 'Remaining Time:',
          'STR_RESULT': 'Test Results',
          'STR_WELLS_INSERTED': 'Did you insert the Samples into the given position?',
          'STR_YES': 'Yes',
          'STR_NO': 'No',
          'STR_LID_CLOSED': 'Did you close the lid?',
          'STR_POSITIVE': 'Positive',
          'STR_NEGATIVE': 'Negative',
          'STR_NEW_TESST': 'New Test',
          'STR_HUMAN_CONTROL': 'Validation',
          'STR_VALID': 'Valid',
          'STR_INVALID': 'Invalid',
          'STR_SHUTDOWN': 'Shutdown',
          'STR_NEW_TEST': 'New Test',
          'STR_STATISTICS': 'Statistics',
          'STR_SERVICESTATUS': 'Service Status',
          'STR_OPENLID': 'Open Lid',
          'STR_OVERVIEW': 'Overview',
          'STR_LAST8TESTS': 'Your last 8 tests',
          'STR_TOTALTESTS':'Total Tests',
          'STR_POSITIVETESTS':'Positives',
          'STR_QUOTEPOSITIVE':'Quote Positive',
          'STR_TESTDATE':'Test Date',
          'STR_SHOW':'Show',
          'STR_TEST_CLEAN1':'This values are cleaned from positive and negative control probes.',
          'STR_TEST_CLEAN2': 'This values are NOT cleaned from positive and negative control probes.',
          'STR_TEST_FROM': 'Test from',
          'STR_MORE_DETAILS': 'STR_MORE_DETAILS',
          'STR_LIVE_SYSSTATUS': 'System Status',
          'STR_MORE_DETAILS': 'More Details:',
          'STR_LIVE_SYSSTATUS1': 'Here you see the live Status of our  most critical systems:',
          'STR_SOFTWARE_UPGRADE': 'We\'ve released a new software for your device. Please click here to apply the changes.',

        },
        de: {
          lang_name: 'Deutsch',
          'de':'Deutsch',
          'en': 'Englisch',
          'ot': 'Andere Sprache',
          'kl': 'Klingonisch',
          'STR_MAINTENANCE': 'Wartung fällig',
          'STR_WELCOME_TO_POC': 'Willkommen bei Ihrem neuen PCR Gerät!',
          'STR_WELCOME_TO_POC1': 'Um Ihr neues PCR System verwenden zu k&ouml;nnen, besuchen Sie bitte unsere Website unter <b>https://pcradmin.procomcure.com/code</b> oder scannen Sie den QR Code auf der linken Seite mit Ihrem Smartphone.',
          'STR_WELCOME_TO_POC2': 'Bitte geben Sie auf unserer Website folgenden Pairing Code an:',
          'STR_WELCOME_TO_POC3': 'Sobald Sie Ihr neues PCR Gerät verbunden haben, wird es einen Neustart durchführen und ist anschließend sofort für Ihren ersten PCR Test verfügbar.',
          'STR_WELCOME_TO_POC4': '<b>Bitte beachten Sie:</b> Ihr PCR Ger&auml;t muss f&uuml;r die Aktivierung, als auch f&uuml;r den regulären Betrieb, &uuml;ber eine <b>dauerhafte</b> und <b>unterbrechungsfreie</b> Internetverbindung verfügen. Wenn Sie uns kontaktieren m&ouml;chten, halten Sie bitte immer Ihre Support ID (<span class="supportid">**supportDetail**</span>) bereit - f&uuml;r Anfragen zu Ihrem PCR Ger&auml;t stehen wir Ihnen gerne unter <b>poc@procomcure.com</b> zur Verf&uuml;gung.',
          'BRANDING': 'PhoenixDx POC',
          'STR_PLEASE_SCAN_SAMPLES': 'Bitte Scannen Sie nun die einzelnen Barcodes.',
          'STR_SAMPLE_POSITIONS': 'Position der Proben:',
          'STR_BARCODE': 'Barcode / Probennummer',
          'STR_START': 'Start',
          'STR_WELCOME': 'Willkommen beim PhoenixDx POC!',
          'STR_WELCOME2': 'Bitte warten.',
          'STR_POSITION': 'Position',
          'STR_TEST': 'Test',
          'STR_TEST_RESULT': 'Test Ergebnis',
          'STR_CT_VALUE': 'CT Wert',
          'STR_TEST_IN_PROGRESS': 'Auswertung läuft',
          'STR_EXPORT_ZMDX': 'Export ZMDX',
          'STR_EXPORT_USB': 'Export USB ',      
          'STR_REMAINING_TIME': 'Verbleibende Zeit:',
          'STR_RESULT': 'Test Ergebnisse',
          'STR_WELLS_INSERTED': 'Haben Sie die Proben in die dafür angegebenen Positionen eingesetzt?',
          'STR_YES': 'Ja',
          'STR_NO': 'Abbrechen',
          'STR_LID_CLOSED': 'Haben Sie das Fach geschlossen?',
          'STR_POSITIVE': 'Positiv',
          'STR_NEGATIVE': 'Negativ',
          'STR_VALID': 'Gültig',
          'STR_INVALID': 'Ungültig',
          'STR_NEW_TESST': 'Neuer Test',
          'STR_HUMAN_CONTROL': 'Kontrolle',
          'STR_SHUTDOWN': 'Gerät herunterfahren',
          'STR_NEW_TEST': 'Neuer Test',
          'STR_STATISTICS': 'Statistiken',
          'STR_SERVICESTATUS': 'Service Status',
          'STR_OPENLID': 'Fach bewegen',

          'STR_OVERVIEW': 'Übersicht',
          'STR_LAST8TESTS': 'Ihre letzten 8 Tests',
          'STR_TOTALTESTS':'Totale Tests',
          'STR_POSITIVETESTS':'Positive',
          'STR_QUOTEPOSITIVE':'Quote Positiv',
          'STR_TESTDATE':'Test Datum',
          'STR_SHOW':'Anzeigen',
          'STR_TEST_CLEAN1':'Diese Werte wurden von Postiven- und negativen Kontrollen bereinigt.',
          'STR_TEST_CLEAN2': 'Diese Werte wurden NICHT von Postiven- und negativen Kontrollen bereinigt.',
          'STR_TEST_FROM': 'Test vom',
          'STR_LIVE_SYSSTATUS': 'System Status',
          'STR_MORE_DETAILS': 'Weitere Details finden Sie hier',
          'STR_LIVE_SYSSTATUS1': 'Auf dieser Seite sehen Sie den Service Status unserer Backend Systeme,<br/>die relevanten Systeme werden im Zyklus von 60 Sekunden rund um die Uhr überwacht.',          
          'STR_SOFTWARE_UPGRADE': 'Für Ihr Gerät liegt eine Software Aktualisierung vor. Klicken Sie <b>hier</b> um die Aktualisierung jetzt durchzuführen. Geplante Dauer: 5 Sekunden.',
        },
        kl: {
          lang_name: 'Te ra\'',
          'de':'DoyIchlan',
          'kl':'tlhIngan',
          'en': 'Te ra\'',
          'ot': '\'uQ\'a\'',
          'STR_MAINTENANCE': 'qevpob',
          'STR_WELCOME_TO_POC': 'HeghlIj yIghoSchoHmoH\'a\'',
          'STR_WELCOME_TO_POC1': '<b>https://pcradmin.procomcure.com/code</b> yoSlIjDaq ghoSchoHmoHlaH pagh, ghoblIj yIlo\'',
          'STR_WELCOME_TO_POC2': 'ja\'chuqmeH ghotpu\'vam, qaStaHvIS.',
          'STR_WELCOME_TO_POC3': 'Hu\'tegh, bI\'IHchugh, vaj ngaghHa\'chugh.',
          'STR_WELCOME_TO_POC4': 'nuHlIjDaq ghoSpu\' chaH. bIyuDHa\'chugh <b>poc@procomcure.com</b> bIquvHa\' \'e\' yIchaw\'. ngoDmeymaj ghoSchoHmoHlu\'bej.',
          'BRANDING': 'ghojmoHwI\'',
          'STR_PLEASE_SCAN_SAMPLES': '/lu\'bogh nuv',
          'STR_SAMPLE_POSITIONS': 'ta\'be\' ghu\'vam.',
          'STR_BARCODE': '/ juH\'laH',
          'STR_START': 'Hov',
          'STR_WELCOME': 'naDev maghoS \'e\' wIpIH.',
          'STR_WELCOME2': 'reynalDo',
          'STR_POSITION': 'polonyuS',
          'STR_TEST': 'waH',
          'STR_TEST_RESULT': 'tlhaw\'DIyuS',
          'STR_CT_VALUE': 'yIn',
          'STR_TEST_IN_PROGRESS': 'pagh qaSbogh wanI\'meyvam\'e\'.',
          'STR_EXPORT_ZMDX': 'choraQ',
          'STR_EXPORT_USB': 'pov ',
          'STR_REMAINING_TIME': 'tlhaw\'DI\' yIleS.',
          'STR_RESULT': 'tlhaw\'DIyuS',
          'STR_WELLS_INSERTED': 'Daja\'meH daqelmeH bIghoS\'a\'?',
          'STR_YES': 'HIja\'',
          'STR_NO': 'Qo\'',
          'STR_LID_CLOSED': '\'ej jup DaghoS\'a\'?',
          'STR_POSITIVE': 'na',
          'STR_NEGATIVE': 'chechHa\'chIch',
          'STR_NEW_TESST': 'Hu\'',
          'STR_HUMAN_CONTROL': 'voqlargh',
          'STR_VALID': 'bIghHa\'',
          'STR_INVALID': 'yIyep',
          'STR_SHUTDOWN': 'jatlh',
          'STR_STATISTICS': 'yo\'',
          'STR_SERVICESTATUS': 'ghe\'\'or',
          'STR_OPENLID': 'pe\'vIl',
          'STR_OVERVIEW': '\'ovelya',
          'STR_LAST8TESTS': 'bIpIv\'a\'',
          'STR_TOTALTESTS':'\'om',
          'STR_POSITIVETESTS':'vaj naHmey',
          'STR_QUOTEPOSITIVE':'Qovpatlh',
          'STR_TESTDATE':'Qo\'noS',
          'STR_SHOW':'\'agh',
          'STR_TEST_CLEAN1':'ghu\'vam vIparHa\'qu\' \'ej ngejtaHbogh qabDaj\'e\'.',
          'STR_TEST_CLEAN2': 'ghu\'vam vIpumlaHbe\' \'ej naghmeyvam vIghajbe\'.',
          'STR_TEST_FROM': 'QIH',
          'STR_MORE_DETAILS': 'STR_MORE_DETAILS',
          'STR_LIVE_SYSSTATUS': 'yab',
          'STR_MORE_DETAILS': 'SoSloDnI:',
          'STR_LIVE_SYSSTATUS1': 'QI\'tu\' DachavtaHvIS, jatlIj lutu\'lu\'be\'mo\':',
          'STR_SOFTWARE_UPGRADE': 'Für Ihr Gerät liegt eine Software Aktualisierung vor. Klicken Sie <b>hier</b> um die Aktualisierung jetzt durchzuführen.',

        },
      }
    } 
  },
  mounted() {


    // 96er erkennung
    let { dev = false } = this.$route.query;
    if(dev) {
      this.deviceType = dev;
    } else {
      this.deviceType = 16;
    }

    this.axios.get("http://127.0.0.1:8441/procomcure?cmd=ping").then((r) => {
      let { hwserial = null, tvid = null } = r.data;
      if(hwserial) {
        this.serial = hwserial;
        this.tvid = tvid;
        return false;
      }
    });

    if(location.search.indexOf("token") > -1) {
      var url = new URL(location.href);
      var token = url.searchParams.get('token')
      this.setToken(token);
      this.launch();
    } else {
      if(localStorage.getItem("token")) {
        this.setToken(localStorage.getItem("token"));
        this.launch();
      } else {
        if(this.debug) this.proxyReachable = true;
        var customer = jwt.decode(token);
        if(customer.sub == "AUTOINSTALL2") {
          this.$router.push({
            name: 'pairing',
          })
        }
      }
    }
  },
  computed: {
    languages() {
      var langs = [];
      Object.keys(this.transl).forEach((r) => {
        langs.push({
          code: r,
          name: this.transl[r].lang_name,
        })
      })
      return langs;
    },
    translation() {
      return this.transl[this.lang]
    },
    supportDetail() {
      if(this.tvid) {
        localStorage.setItem("tvid", this.tvid);
      } else {
        var tt = localStorage.getItem("tvid");
        if(tt) {
          this.tvid = tt;
        }
      }
      return this.tvid;
    },
    getOnlineStatus() {
      return this.online ? "Online" : "Offline";
    }
  },
  methods: {
    devlockf(s) {
      this.devlock = s;
    },
    triggerEasterEggH() {
      this.triggerEasterEgg = true;
      setTimeout(() => {
        this.triggerEasterEgg = false;
      }, 30000)
    },
    reboot() {
      alert("We're now shutting down your device, please restart it afterwards.")
      this.axios.get("http://127.0.0.1:8441/procomcure/?cmd=shutdown").then(() => {
        this.adminModeEnabled = true;
      })
    },
    EnableAdminMode() {
      this.axios.get("http://127.0.0.1:8441/procomcure/?cmd=adminconsole").then(() => {
        this.adminModeEnabled = true;
      })
    },
    ReloadApp() {
      top.location.href= "/";
    },
    GoTo() {
      this.$router.push({
        name: 'support',
      })
    },
    launch() {
      this.checkConnectivity();
      //this.axios.get("https://fax.reisenbauer.at/procomcure/ApoEndpointCheck.php?token="+this.token)
      this.axios.get("https://poc.m26.at/procomcure/ApoEndpointCheck.php?token="+this.token)
      .then((r) => {
        if(r.data.success) {
          this.ApoPortalApiEnabled = true;
        } else {
          this.ApoPortalApiEnabled = false;
        }
      })
      .catch(() => {
          this.ApoPortalApiEnabled = true;
      });


      // GET PARAMETERS
      this.axios.get("/api/screening-portal", { headers: { 'Authorization': 'Barear '+this.token}}).then((r) => {
        this.ScreeningPortalEnabled = r.data.screeningPortal;
      });      


      setInterval(() => {
        this.checkConnectivity();
      }, 15000)
      setInterval(() => {
        var date = new Date();
        var seconds = date.getSeconds() < 10 ? "0"+date.getSeconds() : date.getSeconds();
        var minutes = date.getMinutes() < 10 ? "0"+date.getMinutes() : date.getMinutes();
        var hours = date.getHours() < 10 ? "0"+date.getHours() : date.getHours();
        this.time = hours+":"+minutes+":"+seconds;
      }, 100)      
    },
    setToken(token) {
      localStorage.setItem("token", token);
      this.token = token;
      var customer = jwt.decode(token);
      let { lng = "de" } = customer;
      this.lang = lng;
      localStorage.setItem("lng", this.lang);
      this.customer = customer;
    },
    triggerError(xx) {
      this.axios.post("/api/error-logger", {
        customer: this.customer.id,
        error: xx,
      })
      this.ErrorDescription = xx;
    },
    openLid() {
      this.axios.get("http://127.0.0.1:8441/procomcure/?cmd=openlid")
    },
    setDefaultLanguage() {
      if(this.lang == "ot") {
        this.lang = "en";
        window.open("/lang.html");
      }
      localStorage.setItem("lng", this.lang);
    },
    checkConnectivity() {
      this.axios.get("/api/connectivity/check?mode=spa&serial="+this.serial+"&token="+this.token).then((r) => {
        let { cmd = false } = r.data;
        if(cmd && !this.testrunning) {
          this.axios.get("http://127.0.0.1:8441/procomcure/?cmd="+cmd)
        }
        if(r.data.sub == "AUTOINSTALL") {
          this.ErrorDescription="Device needs personalization.";
          this.provisioned =true;
        }
        if(r.data.sub == "AUTOINSTALL2") {
          this.$router.push({
            name: 'pairing',
          })          
          return false;
        }
        this.customername = r.data.sub;
        this.provisioned =true;
        if(this.version && this.version !== r.data.version) {
          this.showVersionNeg = true;
        } else {
          this.version=r.data.version;
        }
        document.title = r.data.sub+" :: PhoenixDx POC";
      }).catch((e) => {
        if(!this.customername) this.ErrorDescription = e.response.data.error;
      })
      this.axios.get("http://127.0.0.1:8441/procomcure?cmd=ping").then((r) => {
        let { online = false, tvid = null, busy = false,results = false, hwserial = null} = r.data;
        this.online = online;
        this.testrunning = busy;
        this.hasResults = results;
        this.proxyReachable = true;
        this.serial = hwserial;
        this.tvid = tvid;
      }).catch(() => {
        this.online = false;
        this.proxyReachable = true;
        // this.ErrorDescription = "Application not reachable."
      })
    }
  }
}
</script>

<style>
.reboot {
  background-color: #ff4800;
  width: 200px;
  font-size: 12pt;
  padding: 30px;
  text-align: center;
  cursor: pointer;
  position: absolute;
  bottom: 45px;
  right: 45px;
  border: 5px solid red;
    border-image-slice: 1;
  border-image-source: linear-gradient(to left, #743ad5, #d53a9d);
}
:root {
  --primary-color: #00005a;
  --secondary-color: #fff;
}
.adminoverride {
  background-color: red !important;
}
body {
  margin: 0px;
  padding: 0px;
  background-color: black;
  user-select: none;
  overflow: none !important;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: 1px solid black;
  display: flex;
  height: 100vh;
  width: 100vw;
}
* {
  box-sizing: border-box;
}
.black {
  background-color: black !important;
  color: #fff !important;
}
.black * {
  color: #fff;
}
.canvas {
  background-color: #fff;
  height: 799px;
  width: 1280px;
  margin: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
}

header {
  height: 45px;
  padding: 15px;
  width: 100%;
  background-color: var(--primary-color);
  color: var(--secondary-color);
  display: flex;
}
header .branding {
  width: calc(100% - 100px - 80px);
}
header .clock {
  font-weight: 140;
  text-align: center;
  width: 100px;
  font-size: 10pt;
}
.lang {
  margin-bottom: 20px;
  font-size: 10pt;
}
.lang select {
  width: 100%;
  background-color: transparent;
  color: var(--secondary-color);
  border: none !important;
  /* text-transform: uppercase; */
  appearance: none;
}
select option {
  background-color: var(--primary-color);
  color: var(--secondary-color);
}

.lang select:focus {
  outline: none;
}
.lang select::-ms-expand {
    display: none;
}
footer {
  height: 45px;
  padding: 15px;
  width: 100%;
  background-color: var(--primary-color);
  color: var(--secondary-color);
  font-size: 10pt;
  font-weight: 100;
  display: flex;
}
.connectivity {
  width: calc(100%/3);
}
.custname {
  width: calc(100%/3);
  text-align: center;
}
.support {
  width: 200px;
  width: calc(100%/3);
  text-align: right;
  font-size: 15pt;
  padding-bottom: 10px;
}
.support i {
  position: relative;
  bottom: 5px;
  right: 1px;
  cursor: pointer;
}
.approot {
  height: calc(100% - 45px - 45px);
  padding: 15px;
  overflow: auto;
}

thead {
  text-align: left;
  background-color: var(--primary-color);
  color: var(--secondary-color);
}
thead th {
  padding: 10px;
}


.fade-enter-active, .fade-leave-active {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 0.5s, opacity 0.5s linear;
  }
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  visibility: 0;
}
.proxyunreachable {
  height: 100%;
  display: flex;
}

.error {
  margin: auto;
  font-size: 18pt;
  text-align: center;
}

.newversion {
  background-color: #ff4800;
  color: #fff;
  padding: 45px;
  cursor: pointer;
  position: fixed;
  width: 1280px;
    background-image:none !important; 
         -o-animation: fadeIt 5s ease-in-out; 
            animation: fadeIt 5s ease-in-out;

}

@-o-keyframes fadeIt {
  0%   { background-color: #ff4800; }
  50%  { background-color: #AD301B; }
  100% { background-color: #ff4800; }
}
@keyframes fadeIt {
  0%   { background-color: #ff4800; }
  50%  { background-color: #AD301B; }
  100% { background-color: #ff4800; }
}


/* width */
::-webkit-scrollbar {
  width: 30px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: silver;
}


.devlock {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  background-color: black;
  color: #fff;
  display: flex;
  justify-content: center;
  vertical-align: center;
  z-index: 1000;
}
.devlock div {
  margin: auto;
  font-size: 40pt;
}

.spinner-animation{
    width: 500px;
    height: 500px;
    position: relative;
}

.spinner-animation > .spinner{
    width: 400px;
    height: 400px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform-origin: top left;
    transform: translate(-50%,-50%);
    border-radius: 50%;
    box-shadow: inset 3px 3px 3px var(--primary-color);
    animation: spinner 1.2s linear infinite;
}

.spinner-animation > .content{
    display: inline-block;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    text-align: center;
    line-height: 300px;
    color: white;
}


@keyframes spinner {
  0% {
    transform: rotate(0deg) translate(-50%,-50%);
  }
  100% {
    transform: rotate(360deg) translate(-50%,-50%);
  }
}

</style>
